<template>    
        <div class="row justify-content-md-center">
            <b-col md="4">
                <div class="mt-3 mb-5 ml-3">
                    <div class="col-sm-12">
                        <ValidationObserver ref="form">
                            <b-form @submit.prevent="ResetPass" method="post">
                                <b-overlay :show="loading" rounded="sm">
                                    <b-card header="Resetear contraseña">
                                        <b-form-group>
                                            <label>Contraseña <span class="text-danger font-weight-bolder">*</span></label>
                                            <ValidationProvider rules="required|min:8|regex:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)" v-slot="{errors}" name="password" vid="pass_confirmation">
                                                <b-input-group size="sm" class="mb-2">
                                                    <b-form-input v-b-tooltip.hover title="Debe insertar 8 caracteres. Al menos una mayúscula, una minúscula, un número y un caracter especial" 
                                                                  v-model="password" 
                                                                  :type="passwordFieldType" 
                                                                  placeholder="**********"
                                                                  :disabled="disabled">
                                                    </b-form-input>
                                                    <b-input-group-prepend is-text>
                                                        <b-icon :icon="passwordIconType" @click="showPass" style="cursor:pointer"></b-icon>
                                                    </b-input-group-prepend>
                                                </b-input-group>
                                                <span class="text-danger float-left ml-2">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </b-form-group>
                                        <b-form-group>
                                            <label>Confirmar contraseña <span class="text-danger font-weight-bolder">*</span></label>
                                            <ValidationProvider rules="required|min:8|confirmed:pass_confirmation|regex:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)" v-slot="{errors}" name="password">
                                                <b-input-group size="sm" class="mb-2">
                                                    <b-form-input v-b-tooltip.hover title="Debe insertar 8 caracteres. Al menos una mayúscula, una minúscula, un número y un caracter especial" 
                                                                  v-model="confirmation" 
                                                                  :type="passConfirmationFieldType" 
                                                                  placeholder="**********" 
                                                                  @paste.prevent
                                                                  :disabled="disabled">
                                                    </b-form-input>
                                                    <b-input-group-prepend is-text>
                                                        <b-icon :icon="passConfirmationIconType" @click="showPassConfirmation" style="cursor:pointer"></b-icon>
                                                    </b-input-group-prepend>
                                                </b-input-group>
                                                <span class="text-danger float-left ml-2">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </b-form-group>
                                        <div class="mt-2 float-right">
                                            <b-button type="submit" class="is-special" size="sm" :disabled="disabled">Resetear</b-button>
                                        </div>
                                    </b-card>
                                    <template v-slot:overlay>
                                        <div class="text-center">
                                            <b-icon icon="arrow-clockwise" animation="spin" font-scale="3" variant="danger"></b-icon>
                                            <p id="cancel-label">Por favor espere...</p>
                                        </div>
                                    </template>
                                </b-overlay>
                            </b-form>
                        </ValidationObserver>
                    </div>
                </div>
            </b-col>
        </div>      
</template>

<script>  
    import axios from 'axios';
    import { extend } from 'vee-validate';
    import { required, regex, confirmed, min } from 'vee-validate/dist/rules';
    extend('required', required);
    extend('regex', regex);
    extend('confirmed', confirmed);
    extend('min', min);

    extend('required', {
        message: 'Este campo es requerido'
    });

    extend('regex', {
        message: 'Debe insertar al menos una mayúscula, una minúscula, un número y un caracter especial'
    });

    extend('confirmed', {
        message: 'Las contraseñas no coinciden'
    });

    extend('min', {
        message: 'Debe introducir al menos 8 caracteres'
    });

    export default {
        name: 'reset_password',
        data() {
            return {
                password: null,
                confirmation: null,
                passwordFieldType: 'password',
                passwordIconType: 'eye',
                passConfirmationFieldType: 'password',
                passConfirmationIconType: 'eye',
                loading: false,
                username: null,
                security_id: null,
                disabled: false
            }
        }, 
        created() {
            this.validateToken();
        },
        methods: {
            validateToken() {
                if (this.$route.params.username && this.$route.params.securityId) {
                    this.username = this.$route.params.username;
                    this.security_id = this.$route.params.securityId;
                    axios.get('/api/Account/ValidateToken/' + this.username + '/' + this.security_id).then(response => {                      
                        if (!response.data.isSuccesFull) {
                            this.disabled = true;
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Lo sentimos',
                                variant: 'danger',
                                solid: true
                            });
                        }                      
                    });
                }  
            },
            ResetPass() {
                this.loading = true;
                this.$refs.form.validate().then(success => {
                    if (success) {
                        let formData = new FormData();
                        formData.append('Email', this.$route.params.username);
                        formData.append('NewPassword', this.password);
                        formData.append('Token', this.$route.params.securityId);
                        axios.post('/api/Account/ChangePassword', formData).then(response => {
                            this.loading = false;
                            if (response.data.message == 'Change Password Successfully') {
                                this.$root.$bvToast.toast(`Ha cambiado su contraseña satisfactoriamente.`, {
                                    title: 'Enhorabuena!!!',
                                    variant: 'info',
                                    solid: true
                                });
                                this.$router.push({ name: 'auth' });
                            }
                            if (response.data.LoginError) {
                                this.$root.$bvToast.toast('Hay errores en los datos.', {
                                    title: 'Por favor revise',
                                    variant: 'danger',
                                    solid: true
                                });
                                return;
                            }
                        });
                    } else {
                        this.loading = false;
                        this.$root.$bvToast.toast('Hay errores en los datos.', {
                            title: 'Por favor revise',
                            variant: 'danger',
                            solid: true
                        });
                        return;
                    }
                });
            },
            showPass() {
                this.passwordIconType = this.passwordIconType === 'eye' ? 'eye-slash' : 'eye'
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            showPassConfirmation() {
                this.passConfirmationIconType = this.passConfirmationIconType === 'eye' ? 'eye-slash' : 'eye'
                this.passConfirmationFieldType = this.passConfirmationFieldType === 'password' ? 'text' : 'password'
            }
        }
    }
</script>
